// cartBookingSlice.ts
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isBookingCartOpen: false,
  isAddtoBookingCartOpen: false,
  bookingCart: [],
  bookingStaff: [],
  bookingTime: {},
  bookingPaymentMethod: {},
  bookingContactInfo: {},
};

export const cartBookingSlice = createSlice({
  name: "cartBooking",
  initialState,
  reducers: {
    setBookingItems: (state, action) => {
      state.bookingItems = action.payload;
    },

    // addToBookingCart: (state, action) => {
    //   // expect { item }
    //   state.bookingCart = [...state.bookingCart, action.payload.item];
    // },

    addToBookingCart: (state, action) => {
      const item = action.payload.item;
      if (!state.bookingCart.find((x) => x._id === item._id)) {
        state.bookingCart.push(item);
      }
    },

    addStaffToBookingStaff: (state, action) => {
      const item = action.payload.item;
      if (!state.bookingStaff.find((x) => x._id === item._id)) {
        state.bookingStaff.push(item);
      }
    },

    addToCartBookingTime: (state, action) => {
      state.bookingTime = action.payload; // payload is a string
    },

    addToCartBookingPaymentMethod: (state, action) => {
      state.bookingPaymentMethod = action.payload; // payload is a string
    },

    removeFromBookingCart: (state, action) => {
      state.bookingCart = state.bookingCart.filter(
        (item) => item._id !== action.payload._id
      );
    },

    removeStaffFromBookingStaff: (state, action) => {
      state.bookingStaff = state.bookingStaff.filter(
        (item) => item._id !== action.payload._id
      );
    },

    removeTimeFromBookingTime: (state) => {
      state.bookingTime = "";
    },

    increaseBookingCount: (state, action) => {
      state.bookingCart = state.bookingCart.map((item) => {
        if (item._id === action.payload._id) item.count++;
        return item;
      });
    },

    decreaseBookingCount: (state, action) => {
      state.bookingCart = state.bookingCart.map((item) => {
        if (item._id === action.payload._id && item.count > 1) item.count--;
        return item;
      });
    },

    // 👇 accept boolean or toggle if undefined
    setIsBookingCartOpen: (state, action) => {
      const next = action?.payload;
      state.isBookingCartOpen =
        typeof next === "boolean" ? next : !state.isBookingCartOpen;
    },

    setBookingContactInfo: (state, action) => {
      state.bookingContactInfo = action.payload;
    },

    emptyBookingCart: (state) => {
      state.bookingCart = [];
    },

    emptyBookingStaff: (state) => {
      state.bookingStaff = [];
    },

    emptyBookingTime: (state) => {
      state.bookingTime = " ";
    },

    emptyPaymentMethod: (state) => {
      state.bookingPaymentMethod = " ";
    },

    resetBookingState: () => initialState,
  },
});

export const {
  setBookingItems,
  addToBookingCart,
  removeFromBookingCart,
  increaseBookingCount,
  decreaseBookingCount,
  setIsBookingCartOpen,
  setBookingContactInfo,
  emptyBookingCart,

  // bookingStaff
  addStaffToBookingStaff,
  removeStaffFromBookingStaff,
  emptyBookingStaff,

  //booking Time
  addToCartBookingTime,
  removeTimeFromBookingTime,
  emptyBookingTime,

  //booking Payment Method
  addToCartBookingPaymentMethod,
  emptyPaymentMethod,
  resetBookingState,
} = cartBookingSlice.actions;

export default cartBookingSlice.reducer;
